const hi = {
  // Navbar
  nav_home: "होम",
  nav_about: "तेंतेन अंकल के बारे में",
  nav_services: "सेवाएं और मूल्य",
  nav_flow: "सेवा प्रवाह",
  nav_testimonials: "ग्राहक समीक्षाएं",
  nav_faq: "अक्सर पूछे जाने वाले प्रश्न",
  nav_contact: "संपर्क करें",
  nav_cta: "नाम पठन बुक करें",
  nav_subtitle: "नाम पठन · ओकिनावा",
  nav_title: "तेंतेन अंकल का कार्यालय",

  // Hero
  hero_headline1: "शांत",
  hero_headline2: "ओकिनावा द्वीप पर,",
  hero_headline3: "आपके नाम की",
  hero_headline4: "आवाज़ सुनते हैं।",
  hero_body: "नाम पठन की बुकिंग महीनों की प्रतीक्षा सूची में है।\nहर महीने मैं व्यक्तिगत रूप से ओकिनावा द्वीप जाता हूं\nऔर आपका नाम गुरुजी तक पहुंचाता हूं।",
  hero_pill1: "नाम बदलने की जरूरत नहीं",
  hero_pill2: "100% ऑनलाइन",
  hero_pill3: "एक महीने में डिलीवरी",
  hero_pill4: "प्रति माह 100 सीटें",
  hero_btn_apply: "नाम पठन बुक करें",
  hero_btn_services: "सेवाएं देखें",
  hero_scroll: "नीचे स्क्रॉल करें",

  // About
  about_heading: "तेंतेन अंकल के बारे में",
  about_intro: "ओकिनावा के गर्म समुद्र से घिरे शांत <strong>इकेई द्वीप</strong> पर,\nएक ऐसे व्यक्ति रहते हैं जो हर नाम में एक छोटी सी रोशनी जोड़ते हैं।\nलोग उन्हें प्यार से <strong>\"तेंतेन अंकल\"</strong> कहते हैं।",
  about_block1_label: "बैंक कर्मचारी से नाम पाठक तक",
  about_block1_text: "तेंतेन अंकल मूल रूप से एक बैंक कर्मचारी थे।\nलगन से काम करते हुए, वे कंपनी के <strong>सबसे युवा शाखा प्रबंधक</strong> बने।\nकई लोगों से मिलते-मिलते उनके मन में एक सवाल उठा।",
  about_block1_quote: "\"एक ही मेहनत के बावजूद कुछ लोग अनुकूल हवा के साथ आगे बढ़ते क्यों दिखते हैं?\"",
  about_block1_sub: "यह छोटा सा सवाल एक बड़ी खोज की शुरुआत बन गया।",
  about_block2_label: "प्राचीन ज्ञान और शांत प्रकाश",
  about_block2_text: "उन्होंने अपना सारा खाली समय नाम पठन के प्राचीन ग्रंथों के अध्ययन में लगाया, पारंपरिक कांजी रेखाओं और ध्वनि प्रवाह की सावधानीपूर्वक खोज की।",
  about_block2_text2: "उन्हें एहसास हुआ कि <strong>\"तेंतेन बिंदु नाम के प्रवाह को सौम्यता से संतुलित कर सकते हैं।\"</strong>",
  about_block2_sub: "यह कोई नाटकीय जादू नहीं है, न ही कोई अद्भुत सफलता का नुस्खा।\nयह आपके भीतर मौजूद प्रकाश को और स्पष्ट रूप से प्रकट करने का एक सौम्य मार्ग है।",
  about_block3_label: "मुंह से मुंह फैली बात — अब 6 महीने की प्रतीक्षा",
  about_block3_text: "उनकी गर्मजोशी भरी पठन पूरी तरह मुंह से मुंह फैली, और अब <strong>देश भर से बिना रुके पूछताछ आती है</strong>।\nवे सभी के साथ एक ही दिल से व्यवहार करते हैं, चाहे वे प्रसिद्ध हों या नहीं।\nहर नाम पर अपने हाथ रखते हैं और हर व्यक्ति के जीवन के साथ चलते हैं।\nयही है तेंतेन अंकल का तरीका।",

  // Gallery
  gallery_heading: "फोटो गैलरी",
  gallery_sub: "ओकिनावा · इकेई द्वीप",

  // Services
  services_heading: "सेवाएं और मूल्य",
  services_note1: "※ सभी प्लान में गुरुजी की पठन फीस और स्थानीय प्रतिनिधित्व शुल्क शामिल है।",
  services_note2: "※ कोई अतिरिक्त लागत नहीं। आप निश्चिंत हो सकते हैं।",
  services_tab1: "व्यक्तिगत नाम",
  services_tab2: "व्यवसाय का नाम",
  services_tab3: "पालतू जानवर का नाम",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "हम आपकी वृद्धि, वातावरण और हृदय की गतिविधियों को सौम्यता से जांचकर सबसे उपयुक्त तेंतेन बिंदु जोड़ते हैं।",
  services_tab2_desc: "नई चुनौतियों के लिए एक सौम्य हवा लाते हैं। व्यवसाय के प्रवाह को शांति से संतुलित करते हैं।",
  services_tab3_desc: "परिवार के उस सदस्य के लिए जो हमेशा आपके साथ रहता है। उसे शांति और गर्मजोशी से भरा नाम देते हैं।",
  services_row1_target1: "16 वर्ष और उससे अधिक",
  services_row1_target2: "4 से 15 वर्ष",
  services_row1_target3: "0 से 3 वर्ष",
  services_row2_target1: "व्यापार नाम / कंपनी / दुकान",
  services_row3_target1: "पालतू जानवर का नाम",
  services_col_target: "लक्षित वर्ग",
  services_col_price: "मूल्य (कर सहित)",
  services_cta: "यह सेवा बुक करें",
  services_includes_title: "मूल्य में क्या शामिल है (सब कुछ)",
  services_inc1: "नाम पठन",
  services_inc2: "सर्वोत्तम तेंतेन बिंदुओं का सुझाव",
  services_inc3: "बिजनेस कार्ड आकार का कार्ड भेजना (यदि चाहें तो मुफ्त)",
  services_inc4: "शुभ भाग्य सलाह",
  services_inc5: "नाम कार्ड की डिजिटल छवि",
  services_includes_note: "पठन का उद्देश्य नाम में पहले से मौजूद जादू को सौम्यता से प्रकट करना है।",
  services_payment_title: "भुगतान विधि",
  services_payment_method: "बैंक हस्तांतरण (अग्रिम भुगतान)",
  services_payment_desc: "पंजीकरण के बाद, हम आपको बैंक खाते का विवरण प्रदान करेंगे।\nभुगतान पूरा होने पर, शुभ भाग्य का प्रवाह शांति से एकत्रित होने लगता है।",
  services_first_title: "पहली बार आने वालों के लिए",
  services_first_desc: "अनिश्चितता महसूस करना स्वाभाविक है।\nयह भावना एक आंतरिक संकेत है,\nकि एक सौम्य बदलाव शुरू करने का समय आ गया है।",
  services_first_cta: "परामर्श से शुरू करें",

  // Flow
  flow_heading: "सेवा प्रवाह",
  flow_step1_title: "फॉर्म जमा करें",
  flow_step1_c1: "समर्पित फॉर्म में आवश्यक जानकारी दर्ज करें।",
  flow_step1_c2: "जमा करने के 2 से 3 कार्य दिवसों के भीतर हम जवाब देंगे।",
  flow_step1_c3: "ईमेल में अगले चरण और बैंक हस्तांतरण निर्देश शामिल होंगे।",
  flow_step2_title: "पठन शुल्क हस्तांतरित करें",
  flow_step2_c1: "उत्तर ईमेल में निर्दिष्ट खाते में पठन शुल्क हस्तांतरित करें।",
  flow_step2_c2: "भुगतान की पुष्टि के बाद, हम क्रम में पठन की तैयारी शुरू करेंगे।",
  flow_step3_title: "हस्तांतरण पूर्णता सूचना",
  flow_step3_c1: "हस्तांतरण के बाद, ईमेल में निर्दिष्ट पते पर रसीद की छवि भेजें।",
  flow_step3_c2: "पुष्टि के बाद, हम \"पंजीकरण पूर्ण\" संदेश भेजेंगे।",
  flow_step3_note: "इस सूचना के बिना, हम पठन शुरू नहीं कर सकते। कृपया अवश्य भेजें।",
  flow_step4_title: "पठन परिणाम प्राप्त करें",
  flow_step4_c1: "पठन पूर्ण होने के बाद, लगभग एक सप्ताह के भीतर ईमेल द्वारा नाम कार्ड और तेंतेन बिंदुओं की छवि भेजेंगे।",
  flow_step4_c2: "फिर विस्तृत पठन रिपोर्ट और शुभ भाग्य सलाह ईमेल द्वारा भेजेंगे।",
  flow_step5_title: "नाम कार्ड भेजना (वैकल्पिक)",
  flow_step5_c1: "यदि चाहें, तो गुरुजी के हाथ से लिखा बिजनेस कार्ड आकार का कार्ड डाक से भेजेंगे।",
  flow_step5_c2: "कृपया फॉर्म के पते वाले फील्ड में सही डाक पता दर्ज करें।",
  flow_step5_note: "यदि कार्ड की जरूरत नहीं है, तो केवल अपने निवास शहर का नाम दर्ज करें।",
  flow_banner_title: "सब कुछ ऑनलाइन। जापान में कहीं से भी।",
  flow_banner_desc: "ओकिनावा के इकेई द्वीप पर व्यक्तिगत रूप से आने की जरूरत नहीं।\nआप अपनी दैनिक दिनचर्या बदले बिना तुरंत शुरू कर सकते हैं।",
  flow_banner_cta: "अभी पंजीकरण करें",

  // Testimonials
  testimonials_heading: "ग्राहक समीक्षाएं",
  testimonials_viewing: "देख रहे हैं",

  // FAQ
  faq_heading: "अक्सर पूछे जाने वाले प्रश्न",
  faq_cta_title: "और प्रश्न हैं?",
  faq_cta_desc: "कोई भी छोटा सवाल स्वागत योग्य है।\nजो सवाल पूछने में शर्म आती है — वही हम सबसे ज्यादा सुनना चाहते हैं।",
  faq_cta_btn: "प्रश्न पूछें",

  // CTA Banner
  cta_heading1: "निःशुल्क",
  cta_heading2: "परामर्श",
  cta_btn: "अभी बुक करें",

  // Contact
  contact_heading: "संपर्क करें",
  contact_desc: "इस फॉर्म के माध्यम से पठन अनुरोध या पूछताछ भेजें। हम आमतौर पर 2 से 3 कार्य दिवसों के भीतर जवाब देते हैं।",
  contact_address_label: "पता",
  contact_address_value: "तोचिगी, जापान (ऑनलाइन · राष्ट्रव्यापी सेवा)",
  contact_email_label: "ईमेल",
  contact_hours_label: "कार्य घंटे",
  contact_hours_value: "सोम–शुक्र 9:00–18:00 (शनि/रवि/छुट्टियों पर बंद)",
  contact_note_title: "उत्तरों के बारे में",
  contact_note_desc: "उत्तर स्पैम फोल्डर में जा सकते हैं।\nयदि 2 से 3 कार्य दिवसों में उत्तर न मिले, तो सीधे ईमेल से संपर्क करें।",
  contact_field_name: "नाम",
  contact_field_furigana: "फुरिगाना (नाम का उच्चारण)",
  contact_field_email: "ईमेल पता",
  contact_field_phone: "फोन नंबर",
  contact_field_service: "अनुरोधित सेवा",
  contact_field_message: "संदेश",
  contact_placeholder_name: "राम शर्मा",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+91 000 000 0000",
  contact_placeholder_message: "कृपया वह नाम दर्ज करें जिसे आप पढ़वाना चाहते हैं या अपने प्रश्न और अनुरोध।",
  contact_select_placeholder: "चुनें",
  contact_service1: "व्यक्तिगत नाम",
  contact_service2: "व्यवसाय का नाम",
  contact_service3: "पालतू जानवर का नाम",
  contact_service4: "अन्य / पूछताछ",
  contact_submit: "भेजें",
  contact_submitting: "भेज रहे हैं...",
  contact_privacy: "फॉर्म के माध्यम से भेजी गई व्यक्तिगत जानकारी का उपयोग केवल नाम पठन सेवा के लिए किया जाएगा।",
  contact_error: "भेजना विफल रहा। बाद में पुनः प्रयास करें या सीधे ईमेल से संपर्क करें।",
  contact_err_name: "कृपया अपना नाम दर्ज करें",
  contact_err_email_required: "कृपया अपना ईमेल पता दर्ज करें",
  contact_err_email_invalid: "कृपया एक वैध ईमेल पता दर्ज करें",
  contact_err_service: "कृपया एक सेवा चुनें",
  contact_err_message_required: "कृपया एक संदेश दर्ज करें",
  contact_err_message_limit: "संदेश 500 अक्षरों से अधिक नहीं होना चाहिए",
  contact_thanks_title: "संदेश भेजा गया",
  contact_thanks_desc: "संपर्क करने के लिए धन्यवाद।\nआपका संदेश देखने के बाद, हम <strong>2 से 3 कार्य दिवसों</strong> के भीतर जवाब देंगे।\nकृपया प्रतीक्षा करें।",
  contact_thanks_check1: "पुष्टि ईमेल जांचें",
  contact_thanks_check2: "स्पैम फोल्डर भी जांचें",
  contact_thanks_check3: "2 से 3 कार्य दिवसों में उत्तर की प्रतीक्षा करें",
  contact_thanks_another: "एक और संदेश भेजें",

  // Footer
  footer_subtitle: "नाम पठन · ओकिनावा",
  footer_title: "तेंतेन अंकल का कार्यालय",
  footer_desc: "ओकिनावा से पूरे देश में। 50 से अधिक वर्षों के अनुभव वाले नाम पठन गुरु आपके नाम में छिपे भाग्य को सावधानी से पढ़ते हैं।",
  footer_contact_title: "संपर्क जानकारी",
  footer_address_label: "पता",
  footer_address_value: "तोचिगी, जापान\n(ऑनलाइन · राष्ट्रव्यापी सेवा)",
  footer_email_label: "ईमेल",
  footer_hours_label: "कार्य घंटे",
  footer_hours_value: "सोम–शुक्र 9:00–18:00\n(शनि/रवि/छुट्टियों पर बंद)",
  footer_nav_title: "नेविगेशन",
  footer_copyright: "© 2025 तेंतेन अंकल का कार्यालय। सर्वाधिकार सुरक्षित।",
  footer_privacy: "गोपनीयता नीति",
  footer_law: "विशिष्ट वाणिज्य कानून",
  footer_sitemap: "साइटमैप",
};

export default hi;
